import { createSlice } from '@reduxjs/toolkit';
//functions
import deleteAllCookies from '../../functions/deleteAllCookies';
import axios from "../../services";

const initialState = {
    isLogin: localStorage.getItem("at") !== null,
    access_token: localStorage.getItem("at") && JSON.parse(decodeURIComponent(escape(atob((localStorage.getItem("at")))))),
    refresh_token: localStorage.getItem("rt") && JSON.parse(decodeURIComponent(escape(atob((localStorage.getItem("rt"))))))
}

export const authSlice = createSlice({
    name: 'auth',
    initialState,
    reducers: {
        loginHandler: (state, action) => {
            localStorage.setItem("at", btoa(unescape(encodeURIComponent(JSON.stringify(action.payload["access"])))));
            localStorage.setItem("rt", btoa(unescape(encodeURIComponent(JSON.stringify(action.payload["refresh"])))));
            state.access_token = action.payload["access"]
            state.refresh_token = action.payload["refresh"]
            state.isLogin = true
            axios.defaults.headers.common['Authorization'] = `Bearer ${action.payload["access"]}`
        },
        logoutHandler: (state) => {
            deleteAllCookies();
            localStorage.clear();
            state.isLogin = false;
        }
    }
});

// Action creators are generated for each case reducer function
export const {
    loginHandler,
    logoutHandler
} = authSlice.actions

export default authSlice.reducer